exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr th {\n  text-align: center;\n  letter-spacing: 0.02em;\n  vertical-align: middle; }\n\ntr td {\n  height: 10px;\n  padding: 0.2rem; }\n\n.ng-select.custom ::ng-deep .ng-value {\n  color: #19457A;\n  font-weight: bold; }\n\n.table {\n  margin-top: 30px; }\n\n.date-input {\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 20px; }\n\n.date-input-field {\n  min-width: 200px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/partial-report/partial-report.component.scss
// module id = ../../../../../src/app/partial-report/partial-report.component.scss
// module chunks = main